/* Сортировка в коллекциях: перезагрузка страницы + только товары в наличии.
   -----------------------------------------------------------------------
   ЗАЧЕМ. Штатно тема меняет сортировку без перезагрузки: подтягивает секцию
   и заменяет весь блок каталога. Но колонку фильтров рисует приложение
   Power Tools Filter Menu, оно об этой подмене не знает и заново не
   отрисовывается — после сортировки фильтры превращались в пустую колонку.
   Публичного метода перерисовки у приложения нет, поэтому единственный
   надёжный путь — обычный переход по адресу: тогда всё строится с нуля.

   Заодно к сортировке добавляется фильтр «в наличии»: распроданные товары
   в отсортированной выдаче не нужны. Фильтр виден плашкой «In stock» и
   снимается кнопкой Clear all — ничего не прячется молча.

   ДВА РАЗНЫХ ЭЛЕМЕНТА. На широком экране сортировка — выпадающий список
   темы (кнопки с data-value), в мобильной панели «Filter and sort» —
   обычный <select name="sort_by">. Нужны оба обработчика, иначе на
   телефоне остаётся старое поведение со всеми его проблемами.

   Оба висят на фазе перехвата и гасят остальные обработчики: иначе
   сработал бы родной и снова сделал подмену без перезагрузки.
   04.09.2026 */
(function () {
  function go(value) {
    if (!value) return;
    var p = new URLSearchParams(window.location.search);
    p.set("sort_by", value);
    p.set("filter.v.availability", "1");
    p.delete("page");
    window.location.search = p.toString();
  }

  /* широкий экран: выпадающий список темы */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest(".facets--bar .custom-select--item button[data-value]") : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    go(btn.getAttribute("data-value"));
  }, true);

  /* мобильная панель: обычный select */
  document.addEventListener("change", function (e) {
    var s = e.target;
    if (!s || s.tagName !== "SELECT" || s.name !== "sort_by") return;
    if (!s.closest(".facets__mobile_form, #FacetFiltersFormMobile, .facets-mobile")) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    go(s.value);
  }, true);
})();

/* ---------------------------------------------------------------------
   ФИЛЬТРЫ. Та же болезнь, что была у сортировки: тема слушает input на
   форме фильтров, подменяет блок каталога без перезагрузки, а приложение
   Power Tools, которое рисует колонку фильтров, об этом не знает — панель
   оставалась пустой. Проверено замером: 9 438 знаков до клика и 1 967
   после.

   Лечим тем же переходом по адресу. Адрес считаем ровно так же, как тема
   в onSubmitHandler, включая обе её поправки к цене: нижнюю границу 0.00
   и верхнюю, равную максимуму, она из адреса убирает — иначе в ссылке
   болтались бы пустые параметры.

   Задержка 500 мс повторяет debounce темы: у ползунка цены событий много,
   уходить на новый адрес нужно один раз, после того как его отпустили.
   Сортировку пропускаем — ей занимается обработчик выше. 04.09.2026 */
(function () {
  var timer = null;

  function fromForm(form) {
    var sp = new URLSearchParams(new FormData(form));
    if (sp.get("filter.v.price.gte") === "0.00") sp.delete("filter.v.price.gte");
    var slider = document.querySelector(".price_slider");
    if (slider && sp.get("filter.v.price.lte") ===
        parseFloat(slider.dataset.max).toFixed(2)) {
      sp.delete("filter.v.price.lte");
    }
    sp.delete("page");
    window.location.search = sp.toString();
  }

  document.addEventListener("input", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.id === "compare_toggle") return;
    if (t.name === "sort_by") return;
    var form = t.closest("facet-filters-form form");
    if (!form) return;
    e.stopPropagation();
    clearTimeout(timer);
    timer = setTimeout(function () { fromForm(form); }, 500);
  }, true);

  /* Плашки активных фильтров и «Clear all». Классы отличаются от того,
     на что вешается тема (.js-facet-remove в этой версии нет вовсе), но
     кто-то их всё равно перехватывает: клик по плашке очищал адрес без
     перезагрузки и панель фильтров снова становилась пустой. Ловим все
     три варианта.

     Из ссылки берём ТОЛЬКО запрос, путь оставляем текущий: у «Clear all»
     в href стоит родительская коллекция (/collections/single-zone вместо
     /collections/single-zone/wall-mount), и переход по нему увёл бы
     покупателя из той подборки, которую он смотрит. */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest(
      ".js-facet-remove, .active-facets__button, .active-facets__button-remove") : null;
    if (!a || !a.href) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var i = a.href.indexOf("?");
    window.location.search = i === -1 ? "" : a.href.slice(i);
  }, true);
})();
